import type { ChangeEvent } from 'react';
import { createReadableClass } from '@elfsight/widget-utils';
import { type ChoiceFieldValue, useFormDispatch } from '../../contexts';
import type { ChoiceProps } from '../choice';
import { Choice } from '../choice';
import { consentSettings } from './consentSettings';

export type ConsentProps = ChoiceProps & {
  text?: string;
};

export function Consent({
  id,
  value,
  text = consentSettings.text,
  onChange,
  ...forwardingProps
}: ConsentProps) {
  const dispatch = useFormDispatch();
  const handleChecked = (
    _: ChoiceFieldValue | undefined,
    event?: ChangeEvent<HTMLInputElement>
  ) => {
    const value = event?.target.checked ? 'Yes' : undefined;

    onChange?.(value);
    dispatch({
      type: 'changeField',
      field: {
        id,
        value,
        type: 'consent'
      }
    });
  };

  return (
    <Choice
      {...forwardingProps}
      id={id}
      className={createReadableClass({
        component: 'fields',
        element: 'consent'
      })}
      value={value}
      checked={value === 'Yes'}
      options={[
        {
          id: 'consent',
          name: text
        }
      ]}
      otherOption={false}
      onChange={handleChecked}
      onFocus={(e) => e.stopPropagation()}
      multiple
    />
  );
}
